module.exports = __webpack_public_path__ + "c67fcd80821e29999960ce0b7338fb9a.png";